import React from 'react'
import Footer from '../Components/Outlets/Footer'
import Nav from '../Components/Outlets/Nav'
import about from '../Assets/about-gd-img.png'
import Cariculam from '../Assets/Cariculam.png'
import chair from '../Assets/founder.png'

import { Link } from 'react-router-dom'
const AboutPage = () => {
	return (
		<div>
			<Nav />

				<div class="about-page-main">
					<div className="path-menu">
						<div className="container-main">
							<h2 class="page-heading-name mb-0">About Us</h2>
						</div>
					</div>
					<div className="about-section-pg">
					<div className="main-padding">
						<div className="container-main">
							<div className="main">
								<div className="row">
									<div className="col-lg-6">
										<div className="chairman-message-dv">
											<h2 className='chairman-text'>Chairman Message</h2>
											<p className='text-about-sub top'>Knowledge has been the normative and civilizational imperative for both males and females in Islamic world. However, it is a hard truth that the suitable and convenient facilities for the women education is also very much lacking. This lacking, which will surely hamper the female pursuit of keeping in  pace with the advancing surroundings, will reflect in the growth of overall community.
											</p>
											<p className='text-about-sub'>It is this factor that pushed me to go forward with the idea of QGarden which will render the amicable and luxurious  ambience for the women to flourish and explore.</p>
										</div>
									</div>
									<div className="col-lg-6">
										<div className="chairman-message-dv">
											<img src={chair} className='chair-man' alt="" />

										</div>
									</div>
								</div>
								<div className="second-row">
									<div className="row">
										<div className="col-lg-6">
											<div className="chairman-message-dv">
												<img src={about} className='about-curved' alt="" />
											</div>
										</div>
										<div className="col-lg-6">
											<div className="chairman-message-dv">
												<h2 className='chairman-text'>Vission</h2>
												<p className='text-about-sub'>Nesting the habitat of education for women who can set the future trajectory of sustained emancipation while keeping intact the values and virtues of tradi- tional integrity.</p>
												<h2 className='chairman-text'>Mission</h2>
												<div className='flx-span'><span>1.</span> <p className='text-about-sub mz'> Setting up an exclusive and advanced academic atmosphere of learning for girls.</p></div>
												<div className='flx-span'><span>2.</span>	<p className='text-about-sub mz'> Enhancing the memorization skills using traditional and psychological methods.</p></div>
												<div className='flx-span'><span>3.</span> <p className='text-about-sub mz'> Framing the motherly locus to foster the generations.</p></div>
												<div className='flx-span'><span>4.</span> <p className='text-about-sub mz'> Inculcating moral values by raising spiritual levels of the students.</p></div>
											</div>
										</div>
										<div className="col-lg-12">
											<div className="chairman-message-dv">
												<h2 className='chairman-text'>Our Carriculum</h2>
												<p className='text-about-sub'>Psychologically administered pedagogy that can boost memorizing skills along with inculcation analytic vigor.</p>
												<div className="btns-dvs">
													<Link className='btn btn-curic'>Recitation Science</Link>
													<Link className='btn btn-curic'>Tajweed</Link>
													<Link className='btn btn-curic'>Memorisation</Link>
													<Link className='btn btn-curic'>School education (CBSE/State) Islamic studies													</Link>
													<Link className='btn btn-curic'>Languages (English & Arabic)													</Link>

												</div>
											</div>
										</div>
										<div className="col-lg-12">
											<div className="chairman-message-dv">
												<img src={Cariculam} className='about-cariculam' alt="" />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	)
}

export default AboutPage;